var map = {
	"./ab.png": "2040",
	"./acc.png": "572a",
	"./action.png": "889f",
	"./allegro.png": "46ce",
	"./also.png": "4a20",
	"./im.png": "82d9",
	"./ingram.png": "b5bc",
	"./shoper.png": "7efb",
	"./td.png": "4bda",
	"./techdata.png": "be95",
	"./trello.png": "0d32",
	"./wf.png": "b38a",
	"./wfirma.png": "ff07"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61b0";